import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Link from '@material-ui/core/Link';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import GetAppIcon from '@material-ui/icons/GetApp';
import Typography from '@material-ui/core/Typography';
import VideocamIcon from '@material-ui/icons/Videocam';

const useStyles = makeStyles((theme) => ({
  panel: {
    margin: 50
  },
}));

export default function Geo() {
    const classes = useStyles();

    return (
      <Box color="text.primary" className={classes.panel}>
        <Typography variant="h4">PUBLICATION</Typography>
        <List className={classes.root}>
            <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <MenuBookIcon color="primary"/>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText 
                  primary="Diffraction imaging using Geometric-mean Reverse-Time Migration and Common Reflection Surface. Geophysics, 84(4), 1-39." 
                  secondary="Yin, J., & Nakata, N. (2019)." 
                />
                <ListItemSecondaryAction>
                <Link href="https://library.seg.org/doi/pdf/10.1190/geo2018-0455.1" target="_blank">
                  <GetAppIcon />
                  </Link>
                </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <MenuBookIcon color="primary"/>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText 
                  primary="Microseismic imaging using Geometric-mean Reverse-Time Migration in Hydraulic Fracturing Monitoring. In AGU Fall Meeting Abstracts." 
                  secondary="Yin, J., Ng, R., & Nakata, N. (2017, December)." 
                />
                <ListItemSecondaryAction>
                <Link href="http://adsabs.harvard.edu/abs/2017AGUFMNS31C..05Y" target="_blank">
                  <GetAppIcon />
                  </Link>
                </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <MenuBookIcon color="primary"/>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText 
                  primary="Diffraction imaging with geometric-mean reverse time migration. In SEG Technical Program Expanded Abstracts 2017 (pp. 974-979). Society of Exploration Geophysicists." 
                  secondary="Yin, J., & Nakata, N. (2017)." 
                />
                <ListItemSecondaryAction>
                <Link href="https://library.seg.org/doi/10.1190/segam2017-17681741.1" target="_blank">
                  <GetAppIcon />
                  </Link>
                </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <MenuBookIcon color="primary"/>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText 
                  primary="Separation Method of Diffraction on Post-Stack Record Based on Kernel Principal Component Analysis, Progress in Geophysics (in Chinese), 32(2): 0799-0807, doi: 10.6038/pg20170247." 
                  secondary="Yin, J., Wang, Z., Zhang, P., Liang, Y., Shu, G., & Lv, Y. (2017)." 
                />
                <ListItemSecondaryAction>
                <Link href="http://kns.cnki.net/KCMS/detail/detail.aspx?dbcode=CJFQ&dbname=CJFDLAST2017&filename=DQWJ201702047&v=MzExMDFYMUx1eFlTN0RoMVQzcVRyV00xRnJDVVJMT2ZZK2RwRkNubFZiN0xJVHpjWkxHNEg5Yk1yWTlCWTRSOGU=" target="_blank">
                  <GetAppIcon />
                  </Link>
                </ListItemSecondaryAction>
            </ListItem>
        </List>
        <Typography variant="h4">CONFERENCE</Typography>
        <List className={classes.root}>
            <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <VideocamIcon color="primary"/>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText 
                  primary="Microseismic imaging using Geometric-mean Reverse-Time Migration in Hydraulic Fracturing Monitoring, oral talk at 2017 AGU Fall Meeting, New Orleans, Louisiana, 11-15 December." 
                  secondary="Yin, J.,Ng, R., Nakata, N. (2017)." 
                />
            </ListItem>
            <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <VideocamIcon color="primary"/>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText 
                  primary="Diffraction Imaging with Geometric-mean Reverse-Time Migration, oral talk at International Exposition and 87th Annual Meeting, SEG, Houston, Texas, 24-29 September." 
                  secondary="Yin, J., Nakata, N. (2017)." 
                />
            </ListItem>
            <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <VideocamIcon color="primary"/>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText 
                  primary="Diffraction Imaging using Geometric-mean Reverse-Time Migration, poster at Annual Review Meeting, AASPI, Norman, Oklahoma, 17 November." 
                  secondary="Yin, J., Nakata, N. (2016)." 
                />
            </ListItem>
        </List>
      </Box>
    );
}